// extracted by mini-css-extract-plugin
export default {"container":"MeetingSessionContainer_container__kiGNC","volumeEffect":"MeetingSessionContainer_volumeEffect__D3kNe","me":"MeetingSessionContainer_me__eK2ju"};